import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as c from "./pageHeader.module.scss";
import classNames from "classnames";

const PageHeader = ({ className, children }) => {
  return <section className={classNames(className, c.container)}>{children}</section>;
};

PageHeader.Text = ({ className, children }) => <header className={classNames(className, c.header)}>{children}</header>;
PageHeader.Text.Eyebrow = ({ className, children }) => (
  <h1 className={classNames("eyebrow", className, c.eyebrow)}>{children}</h1>
);
PageHeader.Text.Headline = ({ className, children }) => (
  <h2 className={classNames("h1", className, c.headline)}>{children}</h2>
);
PageHeader.Text.Subheading = ({ className, children }) => (
  <p className={classNames("p2", className, c.subheading)}>{children}</p>
);

PageHeader.Visual = ({ className, children }) => <div className={classNames(className, c.header)}>{children}</div>;
PageHeader.Image = ({ className, image, ...props }) => (
  <GatsbyImage className={classNames(className, c.desktopImage)} image={getImage(image)} loading="eager" {...props} />
);

export { PageHeader };
